import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCreateSurvey } from '../../Hooks/Features/SurveyManagement/useCreateSurvey'
import { dateConvert, renderField } from '../../utils/Helper';
import { InputSwitch } from 'primereact/inputswitch';
import _ from 'underscore';
import QuestionBank from '../../pages/Features/QuestionBank/QuestionBank';

const CreateSurvey = ({ options, onClose, editData, gridData }) => {

    const { formJson, activeStep, handleChange, fieldValues, handleSaveSurvey, handleNext, loader } = useCreateSurvey({ options, onClose, editData, gridData });

    return (
        <div>
            <div className='d-flex justify-content-between px-4'>
                <div className='fw-bold fs-5 w70'>
                    {fieldValues?.survey_name ? `${!_.isEmpty(editData) ? "Editing: " : ""}${fieldValues?.survey_name}` : "Create a New Survey"}
                </div>
                <div className='d-flex gap-4'>
                    {formJson?.map((item) => (
                        <div key={item?.step} className='d-flex flex-column justify-content-center align-items-center c-pointer' onClick={() => handleNext(item?.step)}>
                            <div className={`rounded-circle d-flex justify-content-center align-items-center fw-bold ${activeStep >= item?.step ? "text-white" : "text-black"}`} style={{ width: "35px", height: "35px", backgroundColor: activeStep === item?.step ? "#1e262f" : (activeStep > item?.step ? "#22c55e" : "#e1e6eacc"), fontSize: "1.01rem" }}>{activeStep > item?.step ? <FontAwesomeIcon icon="fa-solid fa-check" /> : String(item?.step)?.padStart(2, "0")}</div>
                            <div className={`${activeStep === item?.step ? "fw-bold" : ""}`}>{item?.label}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='row px-4' style={{ height: "55vh", overflowY: "auto", overflowX: "hidden" }}>
                {activeStep === 1 ? formJson?.[0]?.fields?.map((item, index) => (
                    renderField(item, index, (e) => { handleChange(item, e) }, fieldValues, {})
                ))
                    : activeStep === 2 ?
                        <div>
                            <QuestionBank fromComp="create" questions={fieldValues?.questions} setQuestions={(val) => handleChange({ name: "questions" }, { target: { value: val || [] } })}/>
                        </div>
                        : <div className='border rounded my-3 p-1' style={{ height: "45vh", overflowY: "auto", overflowX: "hidden" }}>
                            {formJson?.[2]?.fields?.map((item, index) => (
                                <div key={index} >
                                    <div className='d-flex justify-content-between align-items-center'>
                                        <div className='fw-semibold p-2' style={{ fontSize: "0.95rem" }}>{item?.label}</div>
                                        <div className='stage-toggle custom-switch-wrapper'>
                                            <InputSwitch
                                                checked={fieldValues?.[item?.key]}
                                                onChange={(e) => handleChange({ name: item?.key }, e)}
                                                disabled={item?.disabled || fieldValues?.survey_status === "closed"}
                                                className='survey-switch'
                                            />
                                        </div>
                                    </div>
                                    {fieldValues?.is_allow_response_edit && item?.key === "is_allow_response_edit" ?
                                        <div className='d-flex flex-column px-2'>
                                            <label className='fw-semibold'>Number of edits allowed <span className='text-danger'>*</span></label>
                                            <input type='number' className='input-dd w20' value={fieldValues?.number_of_response_edit || ""} onChange={(e) => handleChange({ name: "number_of_response_edit" }, e)} min={1} disabled={(fieldValues?.survey_status === "closed" || fieldValues?.survey_status === "active  ") ? true : false}/>
                                        </div>
                                        : <></>}
                                </div>
                            ))}
                        </div>
                }
                {(!_.isEmpty(editData) && activeStep === 1) ?
                    <div className='d-flex gap-4'>
                        <div className='d-flex justify-content-between w50'>
                            <span style={{ color: "grey" }}>Created: </span>
                            <span className='fw-semibold'>{fieldValues?.created_datetime ? dateConvert(fieldValues?.created_datetime, "date-time-months") : "N/A"}</span>
                        </div>
                        <div className='d-flex justify-content-between w50'>
                            <span style={{ color: "grey" }}>Published: </span>
                            <span className='fw-semibold'>{fieldValues?.publish_datetime ? dateConvert(fieldValues?.publish_datetime, "date-time-months") : "N/A"}</span>
                        </div>
                    </div>
                    : <></>}
            </div>

            <div className='d-flex justify-content-between mt-2'>
                {activeStep > 1 ?
                    <button className='sk-btn-primary' onClick={() => handleNext(null, true)}><FontAwesomeIcon icon="fa-solid fa-arrow-left" /> Previous</button>
                    : <div></div>
                }
                {activeStep < 3 ?
                    <button className='sk-btn-primary bg-black text-white' onClick={() => handleNext()}>Next <FontAwesomeIcon icon="fa-solid fa-arrow-right" /></button>
                    : activeStep === 3 ?
                        loader ?
                            <button className="sk-btn-primary bg-black text-white" style={{width: "105px"}}>
                                <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                    <span className="sr-only"></span>
                                </div>
                            </button> :
                            <button className='sk-btn-primary bg-black text-white' onClick={() => handleSaveSurvey(true)}><FontAwesomeIcon icon="fa-solid fa-floppy-disk" /> Save Survey</button>
                        : <div></div>
                }
            </div>
        </div>
    )
}

export default CreateSurvey